export const INVALID_CREDENTIALS = 'auth/INVALID_CREDENTIALS';
export const INVALID_CURRENT_PASSWORD = 'auth/INVALID_CURRENT_PASSWORD';
export const INVALID_EMAIL = 'auth/INVALID_EMAIL';
export const INVALID_TOKEN = 'auth/INVALID_TOKEN';
export const CANNOT_RESET_PASSWORD = 'auth/CANNOT_RESET_PASSWORD';
export const CANNOT_CHANGE_EMAIL = 'auth/CANNOT_CHANGE_EMAIL';
